import React, { useCallback, FC } from 'react';
import { TableBody } from '@dxb-web-ui-framework/design-system';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { NoResultsFoundRow } from '../NoresultsFoundRow/NoResultsFoundRow';
import { TableGridRow } from '../TableGridRow/TableGridRow';
import { ColumnDef, TableGridOptions } from '../../types';
import { defaultCellRenderer } from '../tableGridCellRenderers/tableGridCellRenderers';
import { SkeletonTableGridRow } from '../../Skeleton';

export interface TableGridBodyProps extends TableGridOptions {
  colSpan?: number;
  columnDefs: ColumnDef[];
  rowData: GenericObject[];
  hasSkeleton?: boolean;
  skeletonsToDisplay?: number;
  isTableRowClickable?: boolean;
  isRowSelected?: (rowData: GenericObject) => boolean;
  onClickRow?: Function;
}

// TODO: make the NoResultsFoundRow to have coll span the total columns no by counting visible columnDefs
const TableGridBody: FC<TableGridBodyProps> = ({
  colSpan,
  rowData,
  columnDefs,
  noResultsMsg,
  hasSkeleton,
  isRowSelected,
  isTableRowClickable,
  skeletonsToDisplay,
  onClickRow,
}) => {
  const renderTableBody = useCallback(() => {
    if (hasSkeleton) {
      return (
        <SkeletonTableGridRow
          skeletonsToDisplay={skeletonsToDisplay}
          hasSkeleton={hasSkeleton}
          columnDefs={columnDefs}
        />
      );
    }

    if (isEmpty(rowData)) {
      return <NoResultsFoundRow noResultsMsg={noResultsMsg} colSpan={colSpan} />;
    }

    return rowData.map((rowItemData, rowIndex) => (
      <TableGridRow
        key={`TableRow-${rowItemData[Object.keys(rowItemData)[0]]}-${rowIndex}`}
        columnDefs={columnDefs}
        rowItemData={rowItemData}
        defaultCellRenderer={defaultCellRenderer}
        isRowSelected={isRowSelected}
        onClickRow={onClickRow}
        isTableRowClickable={isTableRowClickable}
      />
    ));
  }, [
    columnDefs,
    colSpan,
    noResultsMsg,
    rowData,
    hasSkeleton,
    skeletonsToDisplay,
    isRowSelected,
    onClickRow,
    isTableRowClickable,
  ]);

  return <TableBody>{renderTableBody()}</TableBody>;
};

export { TableGridBody };
